import { memo, useState } from "react";
import { Accordion } from "react-bootstrap";
import { withNamespaces } from "react-i18next";
import CompanyOverview from "./components/company-overview";
import { Button } from "reactstrap";
import { useHistory } from "react-router-dom";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import { connect } from "react-redux";
import CorporateStructure from "./components/corporate-structure";
import FinancialSummary from "./components/financial-summary";
import FinancialRatios from "./components/financial-ratios";
import PaymentBehavior from "./components/payment-behavior";
import RiskScore from "./components/risk-score";
import OperationalEvents from "./components/operational-events";
import BasicInfosHeader from "../../components/basic-infos-header";

const DNBEnterpriseCompanyDetail = ({ t, detailsQuery, supplierData, ...elseData }) => {
    const history = useHistory();
    const [activeAccordion, setActiveAccordion] = useState(null);

    return (
        <div>
            <div className="d-flex align-items-center justify-content-between mb-5">
                <Button
                    color="secondary"
                    outline
                    onClick={() => {
                        history.push({
                            search: `?tab=kyb`
                        })
                    }}
                >
                    <i className="ri-arrow-left-line me-1" />
                    {t('Back to List')}
                </Button>
            </div>

            <div>
                <Accordion
                    className="custom-accordion"
                    activeKey={['basic-infos', activeAccordion]}
                    defaultActiveKey={activeAccordion}
                >
                    <BasicInfosHeader 
                        detailsQuery={detailsQuery}
                    />

                    <CompanyOverview 
                        activeAccordion={activeAccordion}
                        setActiveAccordion={setActiveAccordion}
                        detailsQuery={detailsQuery}
                    />

                    <CorporateStructure 
                        activeAccordion={activeAccordion}
                        setActiveAccordion={setActiveAccordion}
                        detailsQuery={detailsQuery}
                    />

                    <FinancialSummary 
                        activeAccordion={activeAccordion}
                        setActiveAccordion={setActiveAccordion}
                        detailsQuery={detailsQuery}
                    />

                    <FinancialRatios 
                        activeAccordion={activeAccordion}
                        setActiveAccordion={setActiveAccordion}
                        detailsQuery={detailsQuery}
                    />

                    <PaymentBehavior 
                        activeAccordion={activeAccordion}
                        setActiveAccordion={setActiveAccordion}
                        detailsQuery={detailsQuery}
                    />

                    <RiskScore 
                        activeAccordion={activeAccordion}
                        setActiveAccordion={setActiveAccordion}
                        detailsQuery={detailsQuery}
                    />

                    <OperationalEvents 
                        activeAccordion={activeAccordion}
                        setActiveAccordion={setActiveAccordion}
                        detailsQuery={detailsQuery}
                    />
                </Accordion>
            </div>
        </div>
    )
}

const mapStatetoProps = (state) => {
    return {
        organization  :   state.Organization
    };
};

export default withNamespaces()(
    withRouter(connect(
        mapStatetoProps,
        {}
    )(memo(DNBEnterpriseCompanyDetail)))
);
